export default "__VITE_ASSET__DEKB$14g__"